import { inject } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';

export function initializeApp(): Promise<void> {
    const authService = inject(AuthService);
    const hash = window.location.hash;
    const queryString = hash.includes('?') ? hash.split('?')[1] : null;

    if (!queryString) {
        return Promise.resolve();
    }

    const params = new URLSearchParams(queryString);
    const accessToken = params.get('access');

    if (!accessToken) {
        return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
        authService.authenticate(accessToken).subscribe({
            next: () => {
                history.replaceState(null, '', window.location.pathname + window.location.search + '#/');
                window.location.reload();
                return;
            },
            error: () => {
                resolve();
            }
        });
    });
}
